import React, { createContext, useState, useContext } from 'react'

const UnsavedChangesContext = createContext({
  prompt: () => Promise.resolve(true),
  registerPrompt: () => {},
})

export const UnsavedChangesProvider = ({ children }) => {
  const [promptHandler, setPromptHandler] = useState(() => () => Promise.resolve(true))

  const value = {
    prompt: promptHandler,
    registerPrompt: setPromptHandler,
  }

  return (
    <UnsavedChangesContext.Provider value={value}>
      {children}
    </UnsavedChangesContext.Provider>
  )
}

export const useUnsavedChanges = () => useContext(UnsavedChangesContext)
